import React, { useState } from 'react';
import './CalculatorPage.css';

function CarNumberLuckChecker() {
  const [carNumber, setCarNumber] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (number) => {
    // Placeholder for Car Number Luck calculation logic
    // This will need to be replaced with actual numerology logic
    if (!number) return null;
    let sum = 0;
    const numStr = number.toUpperCase().replace(/[^A-Z0-9]/g, '');

    const charMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < numStr.length; i++) {
      const char = numStr[i];
      if (!isNaN(parseInt(char, 10))) {
        sum += parseInt(char, 10);
      } else if (charMap[char]) {
        sum += charMap[char];
      }
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!carNumber) {
      setError('Please enter a car number.');
      return;
    }

    const calculated = calculate(carNumber);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Car Number Luck ${num}: This is a placeholder explanation for car number luck ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Car Number Luck Checker",
    "description": "Check the numerological luck of your car number.",
    "url": "https://www.yourwebsite.com/car-number-luck-checker",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Check Car Number Luck",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/car-number-luck-checker?carNumber={carNumber}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=carNumber"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Car Number Luck Checker</h1>
      <p className="text-center">Enter your car number to check its numerological luck.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="carNumber">Car Number:</label>
          <input
            type="text"
            id="carNumber"
            className="form-control"
            value={carNumber}
            onChange={(e) => setCarNumber(e.target.value)}
            placeholder="e.g., DL 1C AB 1234"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Luck</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Car Number Luck is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default CarNumberLuckChecker;
